import React, { Component } from 'react';
import { firebaseRef, bookmakers, NOTIFICATION_SOUND_URL } from 'config'
import Select from 'react-select'
import 'react-select/dist/react-select.css'
import GetStartedWidget from './GetStartedWidget'
import { saveEdgebetFilterInCache, getCachedEdgebetFilters } from 'utils/cache'
import Toggle from 'react-toggle'

let bookmakerOptions = Object.keys(bookmakers).map(k => {
  return {
    value: +k,
    label: bookmakers[k]
  }
})

export default class NotificationsIntro extends Component {
  constructor(props) {
    super(props)
    this.firebaseRef = firebaseRef.child('notificationfilters')
    this.onToggleSound = this.onToggleSound.bind(this)
    this.audio = new Audio(NOTIFICATION_SOUND_URL)
    this.state = {
      filters: [],
      isAddingNewEdge: false,
      newFilter: {
        bookmaker: 6,
        edge: 5
      },
      changes: {},
      sound: getCachedEdgebetFilters().sound
    }
  }

  componentDidMount() {
    window.analytics.track('Get started', {
      index: 4
    })
    this.firebaseRef.orderByChild('email').equalTo(this.props.user.email).once('value', snap => {
      if (snap.exists()) {
        let filters = []
        snap.forEach(filter => {
          filters.push(Object.assign({}, filter.val(), { key: filter.key() }))
        })
        this.setState({filters})
      }
    })
  }

  toggleNewFilter(e) {
    e.preventDefault()
    this.setState({
      isAddingNewEdge: !this.state.isAddingNewEdge
    })
  }

  onChangeBookmaker(key, bookmaker) {
    this.setState({
      changes: Object.assign({}, this.state.changes, { [key]: true }),
      filters: this.state.filters.map(f => {
        if (f.key === key)
          return Object.assign({}, f, { bookmaker: bookmaker.value })
        return f
      })
    })
  }

  createNewFilter() {
    let newFilterRef = this.firebaseRef.push()
    let newFilter = {
      email: this.props.user.email,
      ...this.state.newFilter
    }
    newFilterRef.set(newFilter, err => {
      if (!err) {
        this.setState({
          filters: [...this.state.filters, Object.assign({}, newFilter, { key: newFilterRef.key() })],
          isAddingNewEdge: false
        })
      }
    })
  }

  onChangeNewFilterBookmaker(bookmaker) {
    this.setState({
      newFilter: Object.assign({}, this.state.newFilter, { bookmaker: bookmaker.value })
    })
  }

  onChangeNewFilterEdge(e) {
    this.setState({
      newFilter: Object.assign({}, this.state.newFilter, { edge: +e.target.value })
    })
  }

  onDeleteFilter(key) {
    this.firebaseRef.child(key).set({}, err => {
      if (!err) {
        this.setState({
          filters: this.state.filters.filter(f => f.key !== key)
        })
      }
    })
  }

  onSaveFilter(key) {
    let filter = this.state.filters.filter(f => f.key === key)[0]
    this.firebaseRef.child(key).update({
      email: filter.email,
      edge: filter.edge,
      bookmaker: filter.bookmaker
    })
    let changes = Object.assign({}, this.state.changes)
    delete changes[key]
    this.setState({
      changes
    })
  }

  onChangeEdge(key, e) {
    let edge = +e.target.value
    this.setState({
      changes: Object.assign({}, this.state.changes, { [key]: true }),
      filters: this.state.filters.map(f => {
        if (f.key === key)
          return Object.assign({}, f, { edge })
        return f
      })
    })
  }

  onToggleSound(e) {
    if (e.target.checked) {
      this.audio.play()
    }
    saveEdgebetFilterInCache('sound', e.target.checked)
    this.setState({
      sound: e.target.checked
    })
  }
  render() {
    let renderedFilters = this.state.filters.map(filter => {
      return (
        <div className='list-group-item' key={filter.key}>
          <div className='row'>
            <div className='col-md-4'>
              <label>BOOKMAKER</label>
              <Select
                name='bookie'
                options={bookmakerOptions}
                onChange={this.onChangeBookmaker.bind(this, filter.key)}
                placeholder='Bookmaker'
                value={filter.bookmaker}
                clearable={false}
                disabled={false}
              />
            </div>
            <div className='col-md-3'>
              <label>EDGE</label>
              <div className='input-group'>
                <input type='number'
                  className='form-control edge-input'
                  value={filter.edge}
                  onChange={this.onChangeEdge.bind(this, filter.key)}
                />
                <span className='input-group-addon'>%</span>
              </div>
            </div>
            <div className='col-md-5 action-button'>
              <button type='button' className='btn btn-danger pull-right'
                onClick={this.onDeleteFilter.bind(this, filter.key)}>
                Delete
              </button>
              { !!this.state.changes[filter.key] && (
                <button type='button' className='btn btn-success pull-right'
                  onClick={this.onSaveFilter.bind(this, filter.key)}>
                  Save
                </button>
              )}
            </div>
          </div>
        </div>
      )
    })
    if (!this.state.isAddingNewEdge) {
      renderedFilters.push((
        <div className='list-group-item' key={-1}>
          <a href="#" className='list-group-item-heading' onClick={this.toggleNewFilter.bind(this)}>
            <i className='fa fa-plus fa-fw'></i> ADD A NEW EMAIL NOTIFICATION
          </a>
        </div>
      ))
    } else {
      renderedFilters.push(
        (
          <div className='list-group-item' key={-2}>
            <div className='row'>
              <div className='col-sm-4'>
                <label>BOOKMAKER</label>
                <Select
                  ref='newFilterBookmaker'
                  name='bookie'
                  options={bookmakerOptions}
                  onChange={this.onChangeNewFilterBookmaker.bind(this)}
                  placeholder='Bookmaker'
                  value={this.state.newFilter.bookmaker}
                  clearable={false}
                />
              </div>
              <div className='col-sm-2'>
                <label>EDGE</label>
                <div className='input-group'>
                  <input type='number' className='form-control edge-input'
                    placeholder='3' value={this.state.newFilter.edge}
                    onChange={this.onChangeNewFilterEdge.bind(this)}
                  />
                  <span className='input-group-addon'>%</span>
                </div>
              </div>
              <div className='col-sm-6 action-button'>
                <button type='button' className='btn btn-danger pull-right' onClick={this.toggleNewFilter.bind(this)}>Cancel</button>
                <button type='button' className='btn btn-success pull-right' onClick={this.createNewFilter.bind(this)}>Save</button>
              </div>
            </div>
          </div>
        )
      )
    }
    return (
      <GetStartedWidget heading='Always be in the know' content='Get an email when a great bet occurs, so you can place it right away.'>
        <div className='row'>
          <div className='col-md-12'>
            <div id='email-notification-intro' className='email-notifications'>
              <div className='list-group'>
                { renderedFilters }
              </div>
            </div>
          </div>
        </div>
        <p className='description'>Keep the edgebet tab open, and hear a sweet sound when a new edgebet pops up!</p>
        <div className='row'>
          <div className='col-xs-12'>
            <div className='form-group'>
              <label className='col-xs-4 control-label'>Sound notification</label>
              <div className='col-xs-8 react-toggle-form-group'>
                <Toggle
                  defaultChecked={this.state.sound}
                  onChange={this.onToggleSound}
                />
              </div>
            </div>
          </div>
        </div>
        <div className='row'>
          <div className='col-md-4 col-md-offset-4'>
            <button className='btn btn-success' id='dashboard-submit' onClick={this.props.onComplete}> Take me to my dashboard</button>
          </div>
        </div>
      </GetStartedWidget>
    )
  }
}



/** WEBPACK FOOTER **
 ** ./src/components/getstarted/NotificationIntro.js
 **/